import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-slate-300 pt-20 pb-10 border-t border-navy" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12 mb-16" data-id="element-65">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-66">
            <div className="bg-white/95 inline-block p-3 rounded-xl mb-6" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/wwyjC13qZNif2t6LP8y7yJ/KRT-insurance-CA_logo.png" alt="KRT Insurance Services & Consulting" className="h-14 w-auto object-contain" data-id="element-68" />
            </div>
            <p className="text-sm leading-relaxed mb-6 italic text-slate-400" data-id="element-69">
              ...putting the care back in healthcare.
            </p>
            <p className="text-sm leading-relaxed mb-6" data-id="element-70">
              Your trusted independent insurance agency. We compare top carriers
              to find you the perfect coverage at the best price.
            </p>
            <div className="flex gap-4" data-id="element-71">
              <a href="#" className="text-slate-400 hover:text-accent transition-colors" data-id="element-72">
                <Facebook className="w-5 h-5" data-id="element-73" />
              </a>
              <a href="#" className="text-slate-400 hover:text-accent transition-colors" data-id="element-74">
                <Twitter className="w-5 h-5" data-id="element-75" />
              </a>
              <a href="#" className="text-slate-400 hover:text-accent transition-colors" data-id="element-76">
                <Linkedin className="w-5 h-5" data-id="element-77" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div data-id="element-78">
            <h4 className="text-white font-bold mb-6" data-id="element-79">Services</h4>
            <ul className="space-y-3 text-sm" data-id="element-80">
              <li data-id="element-81">
                <Link to="/services/healthcare" className="hover:text-accent transition-colors" data-id="element-82">
                  Healthcare Insurance
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/services/benefits-review" className="hover:text-accent transition-colors" data-id="element-84">
                  Benefits Review
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/services/workers-comp" className="hover:text-accent transition-colors" data-id="element-86">
                  Workers Comp Consulting
                </Link>
              </li>
            </ul>
          </div>

          {/* Coverage Column */}
          <div data-id="element-87">
            <h4 className="text-white font-bold mb-6" data-id="element-88">Coverage</h4>
            <ul className="space-y-3 text-sm" data-id="element-89">
              <li data-id="element-90">
                <Link to="/insurance/medicare" className="hover:text-accent transition-colors" data-id="element-91">
                  Medicare Insurance
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/insurance/health" className="hover:text-accent transition-colors" data-id="element-93">
                  Individual & Family Health
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/insurance/life" className="hover:text-accent transition-colors" data-id="element-95">
                  Life Insurance
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/insurance/dental-vision" className="hover:text-accent transition-colors" data-id="element-97">
                  Dental & Vision
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/insurance/disability" className="hover:text-accent transition-colors" data-id="element-99">
                  Disability Insurance
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/insurance/travel" className="hover:text-accent transition-colors" data-id="element-101">
                  Travel Medical
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/insurance/employer-group" className="hover:text-accent transition-colors" data-id="element-103">
                  Employer Group Benefits
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-104">
            <h4 className="text-white font-bold mb-6" data-id="element-105">Contact Us</h4>
            <ul className="space-y-4 text-sm" data-id="element-106">
              <li className="flex items-start gap-3" data-id="element-107">
                <Phone className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-108" />
                <div data-id="element-109">
                  <a href="tel:+17147264999" className="hover:text-accent transition-colors block font-semibold text-white" data-id="element-110">
                    (714) 726-4999
                  </a>
                  <span className="text-xs text-slate-500" data-id="element-111">
                    Mon-Fri, 8am-6pm PST
                  </span>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-112">
                <Mail className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-113" />
                <a href="mailto:info@krtinsurance.com" className="hover:text-accent transition-colors" data-id="element-114">
                  info@krtinsurance.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-115">
                <MapPin className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-116" />
                <span data-id="element-117">
                  Orange County, CA
                  {/* TODO: Update with real street address from client */}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-navy/50 text-center text-sm text-slate-500" data-id="element-118">
          <p data-id="element-119">
            &copy; {new Date().getFullYear()} KRT Insurance Services &
            Consulting. All rights reserved.
          </p>
          <p className="mt-2 text-xs" data-id="element-120">
            Not affiliated with or endorsed by the government or federal
            Medicare program.
          </p>
        </div>
      </div>
    </footer>;
}